<div
  class="reschedule"
  data-testid="reschedule-dialog"
  role="dialog"
  [attr.aria-label]="hearingText.title()"
>
  <div class="reschedule__header">
    <div class="reschedule__heading">
      <h2 class="reschedule__title">{{ hearingText.title() }}</h2>
      <p class="reschedule__subtitle" data-testid="reschedule-subject">
        {{ formatPersonName(data.hearing.title) }} ({{
          data.hearing.proceedingNumber
        }})
      </p>
    </div>
    <button
      type="button"
      class="reschedule__close"
      aria-label="Close"
      data-testid="reschedule-close"
      (click)="cancel()"
    >
      &times;
    </button>
  </div>

  <div class="reschedule__body">
    <div class="reschedule__field">
      <label class="reschedule__label" for="reschedule-date">Date</label>
      <input
        id="reschedule-date"
        class="reschedule__input"
        type="date"
        data-testid="reschedule-date"
        [(ngModel)]="date"
        [disabled]="isSaving()"
      />
    </div>

    <div class="reschedule__row">
      <div class="reschedule__field">
        <label class="reschedule__label" for="reschedule-start"
          >Start time</label
        >
        <input
          id="reschedule-start"
          class="reschedule__input"
          type="time"
          data-testid="reschedule-start-time"
          [(ngModel)]="startTime"
          [disabled]="isSaving()"
        />
      </div>
      <div class="reschedule__field">
        <label class="reschedule__label" for="reschedule-end">End time</label>
        <input
          id="reschedule-end"
          class="reschedule__input"
          type="time"
          data-testid="reschedule-end-time"
          [(ngModel)]="endTime"
          [disabled]="isSaving()"
        />
      </div>
    </div>

    <div class="reschedule__field">
      <label class="reschedule__label" for="reschedule-location"
        >Location</label
      >
      <input
        id="reschedule-location"
        class="reschedule__input"
        type="text"
        data-testid="reschedule-location"
        placeholder="Location name"
        [(ngModel)]="locationName"
        [disabled]="isSaving()"
      />
    </div>

    <div class="reschedule__field">
      <label class="reschedule__label" for="reschedule-room">Room</label>
      <input
        id="reschedule-room"
        class="reschedule__input"
        type="text"
        data-testid="reschedule-room"
        placeholder="Room name"
        [(ngModel)]="roomName"
        [disabled]="isSaving()"
      />
    </div>
  </div>

  <div class="reschedule__footer">
    <button
      type="button"
      class="reschedule__button reschedule__button--secondary"
      data-testid="reschedule-cancel"
      [disabled]="isSaving()"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="reschedule__button reschedule__button--primary"
      data-testid="reschedule-save"
      [disabled]="isSaving()"
      (click)="save()"
    >
      {{ isSaving() ? "Saving…" : "Save New Schedule" }}
    </button>
  </div>
</div>
